/**
 * HOME.JS — Interações da Home
 * SetupForge — Deep Signal Design System
 */

(function() {
  'use strict';

  // ==========================================================================
  // IntersectionObserver — Reveal Animation
  // ==========================================================================

  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        // Opcional: desconectar após revelar (performance)
        // revealObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observar todos os elementos .reveal
  document.querySelectorAll('.reveal').forEach(el => {
    revealObserver.observe(el);
  });

  // ==========================================================================
  // Parallax Simples (Hero e outras sections)
  // ==========================================================================

  const parallaxElements = document.querySelectorAll('.js-parallax');

  if (parallaxElements.length > 0 && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    let ticking = false;

    function updateParallax() {
      const scrollY = window.pageYOffset;

      parallaxElements.forEach(el => {
        const speed = parseFloat(el.dataset.speed) || 0.1;
        const yPos = -(scrollY * speed);
        el.style.transform = `translateY(${yPos}px)`;
      });

      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    });
  }

  // ==========================================================================
  // Featured Products — Image Swap no Hover
  // ==========================================================================

  const productCards = document.querySelectorAll('.prod-card');

  productCards.forEach(card => {
    const img = card.querySelector('.prod-img img');
    if (!img) return;

    const productUrl = card.querySelector('a')?.href;
    if (!productUrl) return;

    // Tentar encontrar segunda imagem do produto (via data attribute ou fetch)
    // Para manter leve, vamos usar um data-attribute se disponível
    const secondaryImage = card.dataset.secondaryImage;

    if (secondaryImage) {
      const originalSrc = img.src;

      card.addEventListener('mouseenter', () => {
        img.src = secondaryImage;
      });

      card.addEventListener('mouseleave', () => {
        img.src = originalSrc;
      });
    }
  });

  // ==========================================================================
  // Quick Add to Cart (se implementado no product-card)
  // ==========================================================================

  document.addEventListener('submit', (e) => {
    if (e.target.matches('.prod-card form')) {
      e.preventDefault();

      const form = e.target;
      const formData = new FormData(form);
      const button = form.querySelector('button[type="submit"]');
      const originalText = button?.textContent;

      if (button) {
        button.disabled = true;
        button.textContent = '...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          // Disparar evento customizado para abrir Cart Drawer
          document.dispatchEvent(new CustomEvent('cart:add', {
            detail: { item: data }
          }));

          if (button) {
            button.textContent = '✓';
            setTimeout(() => {
              button.textContent = originalText;
              button.disabled = false;
            }, 2000);
          }
        })
        .catch(error => {
          console.error('Erro ao adicionar ao carrinho:', error);
          if (button) {
            button.textContent = 'Erro';
            setTimeout(() => {
              button.textContent = originalText;
              button.disabled = false;
            }, 2000);
          }
        });
    }
  });

  // ==========================================================================
  // Category Tabs (se presente na home)
  // ==========================================================================

  const categoryTabs = document.querySelectorAll('.cat-tab');
  const categoryGroups = document.querySelectorAll('.cat-group');

  categoryTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const targetGroup = tab.dataset.group;

      // Remove active de todos
      categoryTabs.forEach(t => t.classList.remove('is-active'));
      categoryGroups.forEach(g => g.classList.remove('is-active'));

      // Adiciona active ao clicado
      tab.classList.add('is-active');
      const targetElement = document.querySelector(`.cat-group[data-group="${targetGroup}"]`);
      if (targetElement) {
        targetElement.classList.add('is-active');
      }
    });
  });

  // ==========================================================================
  // Video Lifecycle (video-lifestyle.liquid)
  // ==========================================================================

  // Já implementado inline na section, mas podemos otimizar aqui também
  const videoWrappers = document.querySelectorAll('.video-wrapper');

  videoWrappers.forEach(wrapper => {
    const playBtn = wrapper.querySelector('.video-play-btn');
    const iframe = wrapper.querySelector('.video-iframe');

    if (playBtn && iframe) {
      playBtn.addEventListener('click', () => {
        // Carregar iframe somente ao clicar (lazy load)
        if (iframe.dataset.src) {
          iframe.src = iframe.dataset.src;
        }
        wrapper.classList.add('playing');
      });
    }
  });

  // ==========================================================================
  // Performance: Lazy Load de Imagens Pesadas
  // ==========================================================================

  if ('loading' in HTMLImageElement.prototype) {
    // Navegador suporta loading="lazy" nativo
    // Nada a fazer, já está no HTML
  } else {
    // Fallback para navegadores antigos (opcional)
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');

    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
          }
          imageObserver.unobserve(img);
        }
      });
    });

    lazyImages.forEach(img => imageObserver.observe(img));
  }

  // ==========================================================================
  // Console branding (Easter egg)
  // ==========================================================================

  console.log(
    '%cSetupForge',
    'font-family: Rajdhani, sans-serif; font-size: 32px; font-weight: 700; color: #00ff88; text-shadow: 0 0 10px rgba(0,255,136,0.5);'
  );
  console.log(
    '%cDeep Signal Design System — Forjado com precisão.',
    'font-family: Inter, sans-serif; font-size: 14px; color: #888;'
  );

})();
